import { useForm } from "react-hook-form";
import { ClassroomType } from "../../types/Classroom";
import { useMutation } from "react-query";
import { createClassRoom } from "../../services/school/classroom/classroom";
import toast from "react-hot-toast";
import { routes } from "../../routes";
import { useNavigate } from "react-router-dom";
import { useGetFacultiesQuery } from "../../hooks/useGetFacultiesQuery";
import { useGetDepartamentsQuery } from "../../hooks/useGetDepartamentsQuery";
import { useGetClassroomTypesQuery } from "../../hooks/useGetClassroomTypesQuery";
import { Button, Card, Flex, Spinner } from "@radix-ui/themes";
import TextFieldComponent from "../../components/inputs/Textfield/TextfieldComponent";
import SelectComponent from "../../components/inputs/Select/SelectComponent";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { CreateClassroomFormValidation } from "./CreateClassroomFormValidation";
import { yupResolver } from "@hookform/resolvers/yup";
import { useGetUniversitiesQuery } from "../../hooks/useGetUniversitiesQuery";



export const CreateClassroom = () => {
  const mutation = useMutation({ mutationFn: createClassRoom, mutationKey: 'createClassRoom' });

  const navigate = useNavigate();
  const { control, handleSubmit, formState: { errors }, getValues,setValue } = useForm<ClassroomType>
  (
    {
      resolver: yupResolver(CreateClassroomFormValidation),
      defaultValues: {
        description: '',
        idFaculty: ''
      },
      mode: 'onBlur',
      reValidateMode: 'onBlur',
      shouldUseNativeValidation: false,
    }
  );
  const { data:universities, isLoading: isLoadingUniversities, isError: errorUniversities, refetch: refetchUniversities } = useGetUniversitiesQuery({ PageNumber: 1, PageSize: 400 });
  const { data: faculties, isLoading: isLoadingFaculties, isError: errorFaculties ,refetch:refetchFaculties} = useGetFacultiesQuery({ PageNumber: 1, PageSize: 400,IdUniversity:getValues('idUniversity') });
  const { data: departaments, isLoading: isLoadingDepartaments, isError: errorDepartaments, refetch: refreshDepartaments} = useGetDepartamentsQuery({ PageNumber: 1, PageSize: 400, IdFaculty:getValues('idFaculty') }, { enabled: !!getValues('idFaculty')});
  const { data: classroomTypes, isLoading: isLoadingClassroomTypes, isError: errorClassroomTypes, refetch: refreshClassroomType} = useGetClassroomTypesQuery({ PageNumber: 1, PageSize: 400 });


  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Sala criada!");
        navigate(routes.classrooms);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });
  const handleFacultyChange = (idFaculty: string) => {
    setValue('idFaculty', idFaculty);
    refreshDepartaments();
  };
  const handleBack = () => {
    navigate(routes.classrooms);
  }
  const handleUniversityChange = (id: string) => {
    setValue('idUniversity', id);
    setValue('idFaculty', '');
    setValue('idDepartament', '');
    refetchFaculties();
  };
  return (
    <form onSubmit={onSubmit} noValidate>
      <Card size='1'>
        <Flex direction='column' gap='4'>
          <TextFieldComponent name="description" label="Descrição" control={control} errors={errors} fieldProps={{ placeholder: 'Descrição' }} required={true}/>
          <SelectComponent
            name="idUniversity"
            label="Instituição de Ensino Superior"
            control={control}
            errors={errors}
            style={{ width: '100%' }}
            options={universities?.items.map(u => ({
              value: u.id ?? "",
              label: u.description ?? ""
            }))}
            itemsLoading={isLoadingUniversities}
            itemsError={errorUniversities}
            onSelect={handleUniversityChange}
            required={true}
          />
          <SelectComponent itemsError={errorFaculties} itemsLoading={isLoadingFaculties} name="idFaculty" label="Unidade orgânica" control={control} errors={errors} style={{ width: '100%' }}
                options={faculties?.items.map(faculty => ({
                  value: faculty.id ?? "",
                  label: faculty.description ?? ""
                }))}
                onSelect={handleFacultyChange}
                required={true}
              />
              <SelectComponent itemsError={errorDepartaments} itemsLoading={isLoadingDepartaments} name="idDepartament" label="Departamento" control={control} errors={errors} style={{ width: '100%' }}
                options={departaments?.items.map(d => ({
                  value: d.id ?? "",
                  label: d.description ?? ""
                }))}
                required={true}
              />
              <SelectComponent itemsError={errorClassroomTypes} itemsLoading={isLoadingClassroomTypes} name="idClassroomType" label="Tipo de sala" control={control} errors={errors} style={{ width: '100%' }}
                options={classroomTypes?.items.map(c => ({
                  value: c.id ?? "",
                  label: c.description ?? ""
                }))}
                required={true}
              />
              
          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> Voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading} variant='surface'  >
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              Registar
            </Button>
          </Flex>

        </Flex>
      </Card>
      
    </form>
  );
}
